<script setup lang="ts">

</script>

<template>
  <div w-full>
    <!-- <div translate-y--20px text-center md:hidden>
      <h1 text-40px font-bold uppercase class="lh-100%">
        MISS W LIVE
      </h1>
      <h2 mt-20px text-16px font-bold uppercase>
        FEATURED LIVE STREAMING<br>COMING SOON
      </h2>
    </div> -->

    <div row items-center justify-center pt-30px lg:pt-77px>
      <button class="p-[12px_0px] lg:p-[20px_24px]" btn-primary w-150px rounded-12px lg:w-295px>
        AMBASSADORS
      </button>

      <button class="b-1 b-#ce0000 p-[12px_0px] !bg-transparent lg:p-[20px_24px]" ml-22.5px btn w-150px rounded-12px lg:ml-80px lg:w-295px>
        PATRONS
      </button>
    </div>
  </div>
</template>

<style scoped>

</style>
